export const getIsAuthPage = (pathname: string) => pathname.includes('/auth');
